import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tag",
  "use": "tag-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"tag\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.753 9.096l-6.657 6.657a.5.5 0 01-.707 0L1.146 8.51A.5.5 0 011 8.157V3.013C1 2.679 1 1 2.992 1h5.165a.5.5 0 01.353.146l7.243 7.243a.5.5 0 010 .707zM2 2.982V7.95l6.743 6.742 5.95-5.95L7.95 2h-4.9C2 2 2 2.982 2 2.982zM5 6a1 1 0 100-2 1 1 0 000 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol